import { Table } from "antd";
import { formatRupee } from "../../../../utils";

interface DpdBucketProps {
  data: any[];
  loading: boolean;
}

const DpdBucket = ({ data, loading }: DpdBucketProps)    => {
  const ALL_DPD_BUCKETS = [
  "0–30 Days",
   "30–60 Days",
    "60–90 Days",
  "90–120 Days",
    "120–150 Days",
  "150–180 Days",
   "180–270 Days",
   "270–365 Days",
  "365–500 Days",
  "500–730 Days",
   "730–1095 Days",
  "1095+ Days",
];
  const createEmptyBucket = (bucketName: string) => ({
  bucketName,
  originalPrincipal: 0,
  osValue: 0,
  totalBorrowers: 0,
  min: 0,
  max: 0,
  average: 0,
  median: 0,
});
const normalizeDpdData = (data: any[] = []) => {
  const map = new Map(
    data.map(item => [item.bucketName, item])
  );

  return ALL_DPD_BUCKETS.map(bucket =>
    map.get(bucket) || createEmptyBucket(bucket)
  );
};

 const preDpdTableColumn = [
  { title: "DPD Bucket", dataIndex: "bucketName", key: "bucketName" },
  { title: "Original Principal", dataIndex: "originalPrincipal", key: "originalPrincipal" , render: (originalPrincipal:any) => <span>{formatRupee(originalPrincipal) || "-"}</span>,},
  { title: "Outstanding Value", dataIndex: "osValue", key: "osValue",render: (osValue:any) => <span>{formatRupee(osValue) || "-"}</span>,} ,
  { title: "Total Borrowers", dataIndex: "totalBorrowers", key: "totalBorrowers" },
  { title: "Min O/S", dataIndex: "min", key: "min",render: (min:any) => <span>{formatRupee(min) || "-"}</span> },
  { title: "Max O/S", dataIndex: "max", key: "max",render: (max:any) => <span>{formatRupee(max) || "-"}</span> },
  { title: "Average O/S", dataIndex: "average", key: "average",render: (average:any) => <span>{formatRupee(average) || "-"}</span> },
  { title: "Median O/S", dataIndex: "median", key: "median" ,render: (median:any) => <span>{formatRupee(median) || "-"}</span> },
];
const normalizedData = normalizeDpdData(data);

  return (
 <div className="mt-10">
   <Table
        // loading={isPhonebookPending || isPhonebookRefetching}
        columns={preDpdTableColumn}
        dataSource={ normalizedData || []}
        size="middle"
        pagination={false}
        style={{ cursor: "pointer" }}
      />
         <div className="mt-4 text-sm text-gray-600">
        <strong>Abbreviations:</strong>
        <ul className="list-disc flex justify-between ml-6 mt-1">
          <li><strong>Min O/S</strong> – Minimum Outstanding</li>
          <li><strong>Max O/S</strong> – Maximum Outstanding</li>
          <li><strong>Average O/S</strong> – Average Outstanding</li>
          <li><strong>Median O/S</strong> – Median Outstanding</li>
        </ul>
      </div>
 </div>
  );
};

export default DpdBucket;